import { useLocation, useNavigate } from "react-router-dom";
import { PillTabs } from "@/components/common";
import { PATHS } from "@/lib/router";
import { useTran } from "@/hooks";
import { TableProperties, List } from "lucide-react";

const PATH_TO_TAB = {
  [PATHS.DATA_ENTRY_OVERVIEW]: "overview",
};

const TAB_TO_PATH = {
  "data-entry": PATHS.DATA_ENTRY,
  overview: PATHS.DATA_ENTRY_OVERVIEW,
};

const DataEntryNavTabs = () => {
  const { t } = useTran();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const activeTab = PATH_TO_TAB[pathname] || "data-entry";

  const handleChange = (value) => {
    const path = TAB_TO_PATH[value] || PATHS.DATA_ENTRY;
    if (pathname !== path) navigate(path);
  };

  const tabs = [
    { value: "data-entry", label: t("Data Entry"), icon: TableProperties },
    { value: "overview", label: t("Overview"), icon: List },
  ];

  return <PillTabs tabs={tabs} value={activeTab} onChange={handleChange} />;
};

export default DataEntryNavTabs;
